import React from "react";

function Button() {
  return (
    <>
      <button className="p-3 font-bold more-info rounded-md cursor-pointer">
        More info
      </button>
    </>
  );
}

export default Button;
